<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card shadow border-0 rounded-4">
        <div class="card-body p-4">
          <div class="text-center mx-auto py-3">
            <a class="navbar-brand" routerLink="/"><img [src]="logoUrl" [alt]="logoAlt" height="60" /></a>
          </div>

          <ng-container *ngIf="user$ | async as user; else loginFormTemplate">
            <h3 class="mb-4 text-center">You're already signed in</h3>
            <div class="d-flex align-items-center gap-3 justify-content-center flex-column flex-sm-row mb-3">
              <div class="avatar-wrapper">
                <ng-container *ngIf="user.photoUrl; else initialsAvatar">
                  <img [src]="user.photoUrl" class="rounded-circle avatar-img" alt="Profile photo">
                </ng-container>
                <ng-template #initialsAvatar>
                  <div class="avatar bg-primary bg-opacity-10 text-primary">
                    <span class="fw-semibold">{{ getInitials(user) }}</span>
                  </div>
                </ng-template>
              </div>
              <div class="text-center text-sm-start">
                <p class="mb-1 text-muted">You are logged in as</p>
                <h5 class="mb-1">{{ getDisplayName(user) }}</h5>
                <p class="mb-0 text-secondary"><i class="bi bi-envelope me-1"></i>{{ user.email }}</p>
              </div>
            </div>
            <div class="alert alert-success d-flex align-items-center" role="alert">
              <i class="bi bi-check-circle-fill me-2"></i>
              <div>
                Your account is active. Continue to your dashboard or log out to switch accounts.
              </div>
            </div>
            <div class="d-grid gap-2 d-sm-flex justify-content-sm-between align-items-center">
              <button class="btn btn-primary w-100 w-sm-auto" type="button" (click)="goToDashboard()">Go to dashboard</button>
              <button class="btn btn-outline-secondary w-100 w-sm-auto" type="button" (click)="onLogout()">Log out</button>
            </div>
          </ng-container>

          <ng-template #loginFormTemplate>
            <h3 class="mb-4 text-center">Sign In</h3>
            <div class="alert alert-danger" role="alert" *ngIf="errorMessage()">
              <i class="bi bi-exclamation-circle me-2"></i>{{ errorMessage() }}
            </div>
            <form (ngSubmit)="onLogin()" [formGroup]="loginForm">
              <div class="mb-3">
                <label for="email" class="form-label">Email address</label>
                <input type="email" formControlName="email" class="form-control" id="email" placeholder="you@boatmail.com" autocomplete="email">
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <input type="password" formControlName="password" class="form-control" id="password" autocomplete="current-password">
              </div>
              <div class="d-flex justify-content-end mb-3">
                <a class="small text-decoration-none" routerLink="/reset-password" [queryParams]="loginLinkQueryParams">Forgot password?</a>
              </div>
              <button type="submit" class="btn btn-primary w-100" [disabled]="loginForm.invalid || isSubmitting()">
                <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" *ngIf="isSubmitting()"></span>
                Log In
              </button>
            </form>
            <div class="auth-divider my-4"><span>or</span></div>
            <button type="button" class="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-2" (click)="onGoogleSignIn()" [disabled]="isSubmitting()">
              <i class="bi bi-google google-mark" aria-hidden="true"></i>
              Continue with Google
            </button>
            <p class="small text-muted text-center mt-2 mb-0">
              By continuing, you agree to our <a routerLink="/terms-and-conditions">Terms</a> and <a routerLink="/privacy-policy">Privacy Policy</a>.
            </p>
            <div class="text-center mt-3">
              <small>Don't have an account? <a routerLink="/register" [queryParams]="loginLinkQueryParams">Create one</a></small>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
